module.exports = __webpack_public_path__ + "img/pg2-article1.3e648ef6.png";